import { CategoryAttributePlaceholder } from "./CategoryAttributePlaceholder";

export const CategoryPlaceholder = () => {
  return (
    <CategoryAttributePlaceholder
      id="product-category-placeholder"
      title="Product Categories"
    >
      Product Categories offer a more rigid classification system where each
      product belongs to a single category. While this structure supports
      certain use cases, it&apos;s tightly linked to our Spend computation
      model, making it less flexible for dynamic categorization needs.
      Categories are stable and useful for broad classification but are not as
      adaptable for evolving market segments.
    </CategoryAttributePlaceholder>
  );
};
